import React from "react";

export function Petition() {
    return (
        <>
        
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        <center>
        <a href="https://diuy0t6boke2n.cloudfront.net/monroetwp_firecommissioner_petition.pdf"><button>Office of Fire Comissioner Petition</button></a>
        <br/>
        </center>
        </>
    )
}